import { render, staticRenderFns } from "./fen-shi-dan-liang.vue?vue&type=template&id=2617f7ec&scoped=true"
import script from "./fen-shi-dan-liang.vue?vue&type=script&lang=js"
export * from "./fen-shi-dan-liang.vue?vue&type=script&lang=js"
import style0 from "./fen-shi-dan-liang.vue?vue&type=style&index=0&id=2617f7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617f7ec",
  null
  
)

export default component.exports